var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { key: _vm.item.id, staticClass: "msg-item" }, [
        _c("div", { staticClass: "flex-row-between-center" }, [
          _c("div", [
            _c("span", { staticClass: "bold" }, [
              _vm._v("售后单号：" + _vm._s(_vm.item.number))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "c-65" }, [
              _vm._v("（" + _vm._s(_vm.item.strTag) + "）")
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex-row-start-center" },
            [
              _vm.item.processDesc
                ? _c("el-tag", { attrs: { type: "danger" } }, [
                    _vm._v(_vm._s(_vm.item.processDesc))
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.item.timeOut
                ? _c("span", { staticClass: "time-out-txt" }, [
                    _vm._v("已逾期")
                  ])
                : _c("div", [
                    _c("span", { staticClass: "m-l-r-8" }, [
                      _vm._v("距离结束")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-item hours" }, [
                      _vm._v(_vm._s(_vm.item.hours || "00"))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-item-point" }, [
                      _vm._v(":")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-item minutes" }, [
                      _vm._v(_vm._s(_vm.item.minutes || "00"))
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-item-point" }, [
                      _vm._v(":")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "time-item seconds" }, [
                      _vm._v(_vm._s(_vm.item.seconds || "00"))
                    ])
                  ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex-row-between-center m-t-8" }, [
          _c("div", { staticStyle: { width: "500px" } }, [
            _c("span", { staticClass: "sku-width" }, [
              _vm._v("SKU：" + _vm._s(_vm.item.ruiguCode))
            ]),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                "商品名称：" +
                  _vm._s(
                    _vm.item.name && _vm.item.name.length > 20
                      ? _vm.item.name.substring(0, 20) + "..."
                      : _vm.item.name || "--"
                  )
              )
            ]),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-top": "4px" } }, [
              _c("span", { staticClass: "sku-width" }, [
                _vm._v(
                  "售后类型：" + _vm._s(_vm._f("asTypeFilter")(_vm.item.asType))
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("逾期时间：" + _vm._s(_vm.item.time))])
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "handle-btn", on: { click: _vm.showDialog } },
            [_vm._v("去处理")]
          )
        ])
      ]),
      _vm._v(" "),
      _c("asOrderDialogVue", {
        ref: "asDialogRef",
        attrs: { item: _vm.item },
        on: { closeDialog: _vm.closeDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04b3b9e7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04b3b9e7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pendingOrder/asOrderItem.vue
// module id = null
// module chunks = 